import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[420px] md:h-[560px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Artistic%20abstract%20illustration%20with%20warm%20peach%20and%20coral%20gradient%20background%2C%20soft%20flowing%20shapes%2C%20dreamy%20atmospheric%20texture%2C%20minimal%20geometric%20elements%2C%20modern%20design%20aesthetic%2C%20subtle%20Japanese%20ink%20brush%20stroke%20inspiration%2C%20clean%20elegant%20composition%2C%20no%20text%2C%20high%20quality%20digital%20art&width=1920&height=800&seq=hero-bg-manga-01&orientation=landscape"
        alt="蜜桃少年漫画 - 073漫画网"
        title="蜜桃少年漫画在线免费阅读 - 073漫画网"
        className="w-full h-full object-cover object-center"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>

      <div className="absolute inset-0 flex items-center justify-center px-4">
        <div className="text-center w-full max-w-3xl">
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-background-50 mb-4 md:mb-6 leading-tight">
            蜜桃少年漫画
          </h1>
          <p className="text-base md:text-lg text-background-200/90 mb-6 md:mb-8 max-w-xl mx-auto leading-relaxed">
            在<strong>073漫画网</strong>，体验<strong>漫画在线免费阅读</strong>的轻松，随时随地继续您的漫画之旅。海量少年漫画资源，高清画质流畅阅读，每日更新精彩不停。
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/category/shaonian"
              className="px-8 py-3 bg-primary-500 text-background-50 font-medium rounded-full text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              开始阅读
              <i className="ri-arrow-right-line ml-2"></i>
            </Link>
            <Link
              to="/category/rexie"
              className="px-8 py-3 bg-background-50/15 backdrop-blur-sm border border-background-50/30 text-background-50 font-medium rounded-full text-sm hover:bg-background-50/25 transition-colors whitespace-nowrap cursor-pointer"
            >
              热门推荐
              <i className="ri-fire-line ml-2"></i>
            </Link>
          </div>

          <div className="flex items-center justify-center gap-8 mt-8 md:mt-10">
            <div className="text-center">
              <p className="text-2xl md:text-3xl font-bold text-background-50">10,000+</p>
              <p className="text-xs md:text-sm text-background-300">漫画作品</p>
            </div>
            <div className="w-px h-10 bg-background-50/20"></div>
            <div className="text-center">
              <p className="text-2xl md:text-3xl font-bold text-background-50">500万+</p>
              <p className="text-xs md:text-sm text-background-300">忠实读者</p>
            </div>
            <div className="w-px h-10 bg-background-50/20"></div>
            <div className="text-center">
              <p className="text-2xl md:text-3xl font-bold text-background-50">每日更新</p>
              <p className="text-xs md:text-sm text-background-300">从不间断</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}